import { FC } from 'react';
import { Table as AntTable, TablePaginationConfig } from 'antd';
import { ColumnsType } from 'antd/lib/table';
import { DeleteOutlined } from '@ant-design/icons';
import { StyledTableHeaderCell, StyledTableWrapper } from 'components/new-ui/base/table/styles';
import EmptyCell from 'components/new-ui/base/emtpy-cell/EmptyCell';
import { CommandButton } from 'components/ui/composed/dashboard/DashboardTable';
import { CommodityCondition } from 'store/commodity-conditions-center/commodityCondition';
import { colors } from 'theme';
import { TableChangeHandler } from 'utils/tableHelpers';

interface Props {
    conditions?: CommodityCondition[];
    loading: boolean;
    pagination: TablePaginationConfig;
    onChange: TableChangeHandler<CommodityCondition>;
    onOpen: (condition: CommodityCondition) => void;
    onDelete: (condition: CommodityCondition) => void;
}

// The column keys are the sort fields the BE accepts
const CommodityConditionsTable: FC<Props> = ({ conditions, loading, pagination, onChange, onOpen, onDelete }) => {
    const columns: ColumnsType<CommodityCondition> = [
        { title: 'Commodity Code', key: 'COMMODITY_CODE', sorter: true, render: (_, record) => record.commodityCode },
        { title: 'TARIC Code', key: 'TARIC_CODE', sorter: true, render: (_, record) => record.taricCode },
        {
            title: 'Country of Origin',
            key: 'COUNTRY_ORIGIN',
            sorter: true,
            render: (_, record) => record.countryOrigin,
        },
        {
            title: 'Condition Codes',
            key: 'conditionCodes',
            ellipsis: true,
            render: (_, record) => (record.conditionCodes.length ? record.conditionCodes.join(', ') : <EmptyCell />),
        },
        {
            title: 'Last Updated',
            key: 'UPDATED_AT',
            sorter: true,
            render: (_, record) => new Date(record.updatedAt).toLocaleString(),
        },
        {
            title: 'Actions',
            key: 'actions',
            align: 'center',
            width: 100,
            render: (_, record) => (
                <CommandButton
                    tooltip="Delete"
                    icon={<DeleteOutlined style={{ color: colors.brand6 }} />}
                    onClick={(event) => {
                        event.stopPropagation();
                        onDelete(record);
                    }}
                />
            ),
        },
    ];

    return (
        <StyledTableWrapper>
            <AntTable<CommodityCondition>
                rowKey="id"
                columns={columns}
                loading={loading}
                dataSource={conditions}
                pagination={pagination}
                onChange={onChange}
                onRow={(record) => ({ style: { cursor: 'pointer' }, onClick: () => onOpen(record) })}
                components={{
                    header: {
                        cell: (props: any) => <StyledTableHeaderCell {...props} />,
                    },
                }}
            />
        </StyledTableWrapper>
    );
};

export default CommodityConditionsTable;
